import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { getUserById } from "~/store/selectors/selector.users";

export const RequireExistingUserAccess = ({ children, redirectTo }) => {
  const { userId } = useParams();
  const user = useSelector((state) => getUserById(state, +userId));

  return user ? children : <Navigate to={redirectTo} />;
};

RequireExistingUserAccess.propTypes = {
  redirectTo: PropTypes.string,
  children: PropTypes.any,
};

RequireExistingUserAccess.defaultProps = {
  redirectTo: "/people",
};
